import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter042() {
  return <KbChapterPage slug="chapter-042" />;
}

(Chapter042 as unknown as { path: string }).path = "/theory-album/042";
